<template>
  <div class="bmcx hello">
    <div class="queryBox">
      <van-field v-model="value" input-align="right" label="请输入身份证号" label-width="106px" :colon="true" :placeholder="placeholderNmae"  maxlength="23"/>
      <van-cell-group class="inputwidth">
        
      </van-cell-group>
    </div>
    <div class="overallCenter btn" :class="value?'btn-Selected':''" @click="sqlist">
      立即查询
    </div> 
    <div v-if="issq" style="margin:20px 0">
      <p>{{list.length==0?'抱歉，暂未查询到报名信息':'已为你查询到的结果如下'}}</p> 
    </div>
    <van-loading style="margin-top:15px" v-if="loading" size="16px" color="#1989fa">数据查询中...</van-loading>
    <div :style="list.length==0?'padding-bottom:50px':''">
      <ul v-for="(item,index) in list" :key="index" >
        <li class="worksLi">
          <p style="font-size:16px;line-height: 40px;">{{item.activityName}}</p>
          <el-descriptions title="" :column="1" border style="margin:10px auto;padding-bottom: 20px;">
            <el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="主体类型" v-if="item.mainBodyType==2">
              团体
            </el-descriptions-item>
            <el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="选手姓名">{{item.babyName}}</el-descriptions-item>
            <el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="就读学校" v-if="item.schoolName">{{item.schoolName}}</el-descriptions-item>
            <el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="指导教师">{{item.teacherName}}</el-descriptions-item> 
            <el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="报名时间">{{item.addTime}}</el-descriptions-item>
            <el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="参赛专业">{{item.majorName}}</el-descriptions-item>
            <el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="参赛组别" v-if="item.mainBodyType==1">{{item.groupName}}</el-descriptions-item> 
            <el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="作品名称">
              {{item.name}}
            <span @click="onPreview(item)" v-if="item.name" style="color: #16d77a;">(查看作品)</span>
            </el-descriptions-item>
            <el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="获奖结果">
              {{ item.prize | prizeName }}
            </el-descriptions-item> 
            <el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="参赛地区">
              {{item.channelName?item.channelName:'个人报名'}}
            </el-descriptions-item>
          </el-descriptions> 
          <van-button size="large" @click="submitFn" color="linear-gradient(to right, #5DD682, #5AFF8E)">确认</van-button>
        </li>
      </ul>
    </div>
    <van-popup v-model="showViewer" class="photo-tags2" closeable position="bottom" :style="{ height: '100%', width: '100%' }" @close="showViewer=false">
      <div class="filelist">
        <div class="filelist-title">查看文件</div>
        <div class="" v-for="(time,index) in imageUrl" :key="index">
          <div class="overallBetween filelist-card">
            <div class="overallLeft">
              <div class="filelist-card-name">{{time.fileType | fileTypeName}}:</div>
              <div class="filelist-card-value">{{time.fileName}}</div>
            </div>
            <div class="filelist-card-btn" @click="getcheck(time)">查看</div>
          </div>
        </div> 
      </div>
    </van-popup>
    <van-popup v-model="checkType" class="photo-tags" closeable position="bottom" :style="{ height: '100%', width: '100%' }" @close="beforeCloseHandler(checkData.fileType)">
      <div class="show-photo-tags">
        <img v-if="checkData.fileType == 1" :src="checkData.fileUrl" alt="" />
        <audio ref="audioPlayer" v-if="checkData.fileType == 2" width="100%" height="200" controls :src="checkData.fileUrl"></audio>
        <video ref="videoPlayer" v-if="checkData.fileType == 3"  width="100%" height="200" controls :src="checkData.fileUrl"></video>
        <p style="text-align: center; margin-top: 20px">
          <a style="font-size: 18px; color: #16d77a" v-if="checkData.fileType == 4" :href="checkData.fileUrl">
            点击查看文档类作品
          </a>
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getWorkMsg,getcertQuery,getWorksDetailsByH5,getWorksCertificateByH5 } from "@/utils/api/home";

import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { getfileTypeArr } from "@/utils/tool";
export default {
  name: 'bmcx',
  components: { ElImageViewer },
  data() {
    return {
      loading:false,
      placeholderNmae:'请输入23位证书编号/作品编号',
      value: '',
      issq:false,
      list:[],
      ValueType:1,
      imageUrl:[],
      showViewer:false,
      checkType:false,
      checkData:{}
    };
  },
  filters:{
    fileTypeName(e){
      let name = '';
      e=e+''
      switch (e) {
        case '1': 
          name= '图片文件';
          break;
        case '2': 
          name= '音频文件';
          break;
        case '3':
          name= '视频文件';
          break;
        case '4':
          name= '文档文件';
          break;
      }
      return name
    },
    prizeName(e){
      let name = '';
      e=e+''
      switch (e) {
        case '校外实践证书': 
          name= '校外实践证书';
          break;
        case '等待成绩发布': 
          name= '等待成绩发布';
          break;
        case '1': 
          name= '一等奖';
          break;
        case '2':
          name= '二等奖';
          break;
        case '3':
          name= '三等奖';
          break;
        case '4':
          name= '优秀奖';
          break;
        default:
        name= '谢谢参与';
      }
      return name
    }
  },
  methods:{
    sqlist(){ 
      this.list=[]
      this.issq=false;
      this.loading = true;
      if(this.value==''){
        this.$message({
          message: '请输入身份证号',
          type: 'warning'
        }); 
        this.loading = false;
        return  
      }
      this.$message({
        message: '暂未开放',
        type: 'warning'
      });
      this.loading = false;
    },
    /**
     * @description: 作品证书
     * @author: wangxiaoheng
     */
    getWorkMsgBt(){
      getWorkMsg({
        code:this.value,
        type:this.ValueType
      }).then(
      (res) => {
        if (res.success) {
          if(res.data!=null){
            this.list.push(res.data)
            this.issq=true
            this.loading = false; 
          }else{
            this.issq=true
            this.loading = false;
            this.list=[] 
          }
        }else{
          this.loading = false;
        }
      }).catch(err=>{
        this.loading = false;
      })
    },
    /**
     * @description: 教师证书
     * @author: wangxiaoheng
     */
    getcertQueryBT(){
      getcertQuery({
        certNo:this.value
      }).then(res=>{
        if (res.success) {
          if(res.data!=null){
            let data = res.data
            if(!data.works||data.works.length<1){
              data.works = [{ babyName:'张塞' }]
            }
            this.list.push(res.data)
            this.issq = true
            this.loading = false;
          }else{
            this.issq=true  
            this.loading = false;
            this.list=[] 
          }
        }else{
          this.loading = false;
        }
      }).catch(err=>{
        this.loading = false;
      })
    },
    
    
    //查看作品
    onPreview(row) { // 开启大图查看器
      this.imageUrl = []
       getWorksDetailsByH5(row.id).then(
        (res) => {
          if (res.success) {  
            if(res.data!=null){
              this.showViewer = true;
              this.imageUrl = getfileTypeArr(res.data.imgs)
            }else{
              this.$message({
                message: '暂无作品',
                type: 'warning'
              });
            }
          }
        })
    } ,
    //查看证书
    onPreviewprize(row){
      this.imageUrl = []
       getWorksCertificateByH5(row.id).then(
        (res) => {
          if (res.success) {
            if(res.data!=null){
              this.showViewer = true;
              this.imageUrl.push(res.data.certUrl)
            }else{
              this.$message({
                message: '暂无证书',
                type: 'warning'
              });
            }
          }
        })
    },
    // 关闭图片查看器
    closeViewer() {
      this.showViewer = false;
    },
    /**
     * @description:  查看文件
     * @param {*} ks
     * @return {*}
     * @author: wangxiaoheng
     */
     getcheck(ks){
      this.checkData = ks;
      this.checkType = true;
    },
    /**
     * @description: 关闭音视频
     * @param {*} index
     * @author: wangxiaoheng
     */
     beforeCloseHandler(){
      if(this.$refs.audioPlayer){
        this.$refs.audioPlayer.pause();
        this.$refs.audioPlayer.currentTime = 0;
      }
      if(this.$refs.videoPlayer){
        this.$refs.videoPlayer.pause();
        this.$refs.videoPlayer.currentTime = 0;
      }
    },
   
  }
}
</script>

<style scoped lang="scss">
.hello{
  padding-top: 1px;
  min-height: 100vh;
  background-color: #F7F7FA;
  background-image: url(../../assets/images/xinxihedui_bg.png);
  background-size: 100% 218px;
  background-repeat: no-repeat;
}
.queryBox{
  width: 345px;
  background: #FFFFFF;
  border-radius: 6px;
  margin: auto;
  margin-top: 171px;
  padding-left: 15px;
  padding-top: 18px;
  padding-right: 15px;
  padding-bottom: 15px;
}
.queryBox-title{
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #404046;
  text-align: left;
}
.queryValue{
  margin-top: 10px;
  div{
    width: 95px;
    height: 29px;
    background: #FFFFFF;
    border: 1px solid #D6DBE0;
    border-radius: 15px;
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #8E8E94;
    margin-right: 15px;
  }
  div:last-child {
    margin-right: 0px;
  }
}
.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
  border-width:0 0;
}
.btn{
  width: 345px;
  height: 40px;
  background: #9FA3AD;
  border-radius: 20px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  margin: 0 auto;
  margin-top: 20px;
}
.btn-Selected{
  background: #63D579;
}
.query-Selected{
  color: #FF7856 !important;
  border: 1px solid #FF7856 !important;
}
.worksLi{
  width:90%;
  margin:30px auto;
  border-radius: 10px;
  box-shadow: 4px 3px 20px #ddd9d9;
  background-color: #ffffff;
  p{
    min-height: 32px;
    background: rgba(86, 159, 255, 0.1);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #569FFF;
  }
}
.filelist{
  width: 300px;
  height: 369px;
  background: #FFFFFF;
  border-radius: 6px;
}
.filelist-card{
  width: 270px;
  height: 45px;
  background: rgba(86, 159, 255, 0.1);
  border-radius: 6px;
  margin: 0 auto;
  margin-top: 15px;
}
.filelist-card-name{
  width: 70px;
  margin-left: 12px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #8E8E94;
}
.filelist-card-value{
  width: 120px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #404046;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.filelist-card-btn{
  margin-right: 10px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #569FFF;
}
.filelist-title{
  margin-top: 15px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #404046;
}
.douyin_img{
  width: 35%;
  vertical-align: middle;
  margin-bottom: 50px;
}
</style>
<style lang="scss">
.bmcx{
  .van-popup.photo-tags2{
    display:flex;
    align-items:center;
    justify-content:center;
    background-color:unset;
  }
  .van-popup.photo-tags {
    background-color: unset;
    .checkClass{
      width: 8.1067rem;
      border-radius: 0.4267rem;
      overflow: hidden;
      margin-top: 5vh;
      display: flex;
    }
    .show-photo-tags {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      overflow: hidden;
      p {
        font-size: 14px;
        text-align: center;
        color: #f2f2f2;
      }
      img {
        width: 304px;
        border-radius: 16px;
        overflow: hidden;
        margin-top: 5vh;
        display: flex;
      }
    }
  }
}
.worksLi{
  .labelclass{
    text-align: center !important;
    background-color: #ffffff;
  }
  .contentClass{
    max-width: 150px;
    text-align: right !important;
  }
  .el-descriptions .is-bordered .el-descriptions-item__cell{
    border-width: 0 0;
  }
}
</style>